module.exports = __webpack_public_path__ + "img/royal-diamond.8a2ba113.png";